import { render } from "./TheLoader.vue?vue&type=template&id=f225a162"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import "./TheLoader.vue?vue&type=style&index=0&id=f225a162&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__